export const googleAnalytics = {
  title: "Google Analytics",
  description:
    "Conecta tu Tracking ID de Google Analytics para medir el tráfico y el comportamiento de tus clientes en la tienda.",
  trackingIdLabel: "Tracking ID",
  trackingIdPlaceholder: "Ej. G-XXXXXXXXXX",
  findId: "¿Cómo encuentro mi ID?",
  save: "Actualizar",
  saving: "Guardando...",
  saveSuccess: "Código de Google Analytics actualizado correctamente",
  saveError: "No se pudo actualizar el código de Google Analytics",
  helpWhatsapp:
    "Hola, necesito ayuda con el complemento de Google Analytics en Domun.",
  acquire: {
    title: "Activa Google Analytics",
    description:
      "Potencia tu negocio con datos precisos sobre el comportamiento de tus clientes.",
    cta: "Adquirir complemento",
  },
  findIdScreen: {
    title: "Encontrar ID",
    stepLabel: "Paso {{step}} de {{maxStep}}",
    gotIt: "Entendido",
    openAnalytics: "Ir a Google Analytics",
    steps: [
      {
        name: "Abre Google Analytics",
        description:
          "Inicia sesión en Google Analytics y selecciona la propiedad de tu tienda.",
      },
      {
        name: "Ve a la configuración",
        description:
          "En Administración, abre la configuración de la propiedad o el flujo de datos web.",
      },
      {
        name: "Copia tu Tracking ID",
        description:
          "Copia el ID de medición (formato G-XXXXXXXX) y pégalo en Domun.",
      },
    ],
  },
};
